import React from 'react'
import {Header} from '@thryvlabs/maverick'
import {ScorePercentage} from './score-percentage'

function RatingLabel({label, score, size = 'h4'}) {
  return (
    <div className="d-flex" data-test="component-score-label">
      <Header fontWeight="semibold" variant={size} className="m-0">
        <span data-test="score-text-label" className="font-bold mr-2">
          {label}:
        </span>
      </Header>
      <ScorePercentage score={score} />
    </div>
  )
}

export {RatingLabel}
